module.exports = "<div [innerHtml] = 'pricacyContent | safeHtml'></div>"